/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_EHS_LIST (state, val) {
    state.ehsList = val
  },
  UPDATE_EHS_LIST (state, val) {
    state.ehsList.push(...val)
  },
  UPDATE_EHS (state, ehs) {        
    const i = state.ehsList.findIndex((e) => e.id === ehs.id)
    Object.assign(state.ehsList[i], ehs)
  },
  DELETE_EHS (state, ehs) {
    const i = state.ehsList.findIndex((e) => e.id == ehs.id)
    state.ehsList.splice(i, 1)
  },
  ADD_EHS (state, ehs) {
    state.ehsList.unshift(ehs)
  },
  CLEAR_EHS_LIST(state){
    state.ehsList={}
  }
  
}
